export enum BENEFIT_REVENUE_TYPES {
  cashback = 'cashback',
  discount = 'discount'
}

export enum DISCOUNT_CODE_TYPES {
  shared = 'shared',
  unique = 'unique'
}

export enum DISCOUNT_TYPES {
  percentage = 'percentage',
  fixed = 'fixed'
}

export enum COMMISSION_TYPES {
  percentage = 'percentage',
  fixed = 'fixed-amount'
}

export enum BENEFIT_AVAILABILITY_TYPES {
  time = 'time_based',
  usage = 'usage_based'
}

export enum BENEFIT_USAGE_TYPES {
  unlimited = 'unlimited',
  single = 'single_use'
}
